import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/home'
import notPage from '@/views/err404'

Vue.use(VueRouter)

const routes = [{
    path: '*',
    name: '404',
    component: Home,
},
{
    path: '/',
    name: 'home',
    component: Home
},
{
    path: '/product/:id',
    name: 'product',
    component: () =>
        import('@/views/product.vue')
},
{
    path: '/about/:id',
    name: 'about',
    component: () =>
        import('@/views/about.vue')
},
{
    path: '/pinfo/:id',
    name: 'pinfo',
    component: () =>
        import('@/views/pinfo.vue')
},
{
    path: '/news/:id',
    name: 'news',
    component: () =>
        import('@/views/news.vue')
},
{
    path: '/search',
    name: 'search',
    component: () =>
        import('@/views/searchinfo.vue')
}
]

const router = new VueRouter({
    routes
})

router.beforeEach(
    (to, from, next) => {
        if (to.name == 'product') {
            switch (parseInt(to.params.id)) {
                case 59:
                    to.params.nid = 2
                    break
                case 62:
                    to.params.nid = 3
                    break
                case 63:
                    to.params.nid = 4
                    break
                case 64:
                    to.params.nid = 11
                    break
                case 1:
                    to.params.nid = 5
                    break
                default:
                    to.params.nid = 18
            }
        }
        if (to.name == 'about') {
            switch (parseInt(to.params.id)) {
                case 1:
                    to.params.nid = 6
                    break
                case 2:
                    to.params.nid = 7
                    break
                case 3:
                    to.params.nid = 8
                    break
                case 4:
                    to.params.nid = 9
                    break
                case 5:
                    to.params.nid = 10
                    break
            }
        }
        if (to.name == 'pinfo') {
            if (!to.params.nid) {
                to.params.nid = 5
            }
        }
        if (to.name == 'news') {
            if (!to.params.nid) {
                to.params.nid = 18
            }
        }
        if (to.name == 'search') {
            to.params.nid = 18
        }
        // 重置滚动距离
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        next();
    }
)


export default router